<template>
  <router-link
    class="nav-link border-radius-md p-0 nav-item-hover"
    :to="to"
    v-bind="$attrs"
    style="overflow: hidden !important; padding: 6px 6px !important"
  >
    <div
      class="text-center bg-white shadow icon icon-shape border-radius-md d-flex align-items-center justify-content-center dark-mode"
      style="width: 2rem; height: 2rem"
      :class="this.$store.state.isRTL ? ' ms-2' : 'me-2'"
    >
      <slot name="icon"></slot>
    </div>
    <span
      class="nav-link-text"
      :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'"
      >{{ navText }}</span
    >
  </router-link>
</template>
<script>
export default {
  name: "sidenav-collapse",
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
};
</script>

<style scoped>
.nav-item-hover {
}
</style>
